/*******************************************************************************
 * Copyright (c) 2024 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

import {Injectable, inject} from '@angular/core';
import {CanActivate, Router, UrlTree} from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable, of, switchMap} from 'rxjs';
import {TokenSelectors} from '@shared/common-core/store/selectors';

/**
 * The guard is used to check if the user is logged in. The Angular CanActivate guard decides, if a route can be activated (or component gets rendered).
 */
@Injectable({
  providedIn: 'root',
})
export class LoggedInGuard implements CanActivate {
  private router = inject(Router);
  private store = inject(Store);

  canActivate(): Observable<boolean | UrlTree> {
    // We should only allow navigation if the user signed the nda, if not, we should redirect back to the sign-nda page
    return this.store.select(TokenSelectors.selectTokenStateValue).pipe(
      switchMap(token => {
        if (!token) return of(this.router.createUrlTree(['/auth/login']));
        return of(true);
      })
    );
  }
}
